module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz13-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_09",
      "id": "CC_09"
    }
  }, [_vm._v("Regal Order Root Beer Ice Cream Fluff")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz13-3"
    }
  }, [_c('i', [_vm._v("Here’s to good fellowship. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-4"
    }
  }, [_c('b', [_vm._v("2 cups root beer ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pz13-5"
    }
  }, [_c('b', [_vm._v("2 cups vanilla ice cream ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz13-6"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("P")]), _vm._v("our ice cold, root beer into a large bowl set in a pan of crushed ice. Add ice cream and beat with a beater until smooth and fluffy. Serve immediately. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz13-7"
    }
  }, [_vm._v("Makes 4 servings. ")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pz13-8"
    }
  }, [_c('i', [_vm._v("Alice Schwenke—Houston, Texas")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b69d7f00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter09.vue
// module id = 90
// module chunks = 0